import * as React from 'react';
import {
    Route,
    Switch,
    RouteComponentProps,
} from "react-router-dom";
import ManageUsersPage from './ManageUsersPage';
import ManageUserDetailPage from './ManageUserDetailPage';

type TParams = { id: string, url: string }

function Notification({ match }: RouteComponentProps<TParams>) {
    return (
      <Switch>
        <Route exact path={`${match.url}`} component={ManageUsersPage} />
        <Route exact path={`${match.url}/edit/:id`} component={ManageUserDetailPage} />
        <Route exact path={`${match.url}/create`} component={ManageUserDetailPage} />
      </Switch>
    );
}

export default Notification;
